export class BatchJob
{
    fileName:string;
    contentType:string;
    content:number[];
}


// WEBPACK FOOTER //
// ./src/app/modules/batch-job/entity/batch-job.ts